  import { proxyBE } from "./common";

export const stewardService = {
  
  lessonOnSiteTrainigSchedule(searchFilter) {
    return proxyBE.get(`steward/lessonOnSiteTrainigSchedule/${JSON.stringify(searchFilter)}`);
  },
};
